
export default {
  name: 'EmailLink',
  props: {
    email: '',
  },
}
